import { render, staticRenderFns } from "./acctInfo.vue?vue&type=template&id=0ba66704"
import script from "./acctInfo.vue?vue&type=script&lang=js"
export * from "./acctInfo.vue?vue&type=script&lang=js"
import style0 from "./acctInfo.vue?vue&type=style&index=0&id=0ba66704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports